import TagManager from 'react-gtm-module';

export const useDetectTrafficSource = ({ source, campaign }) =>
  TagManager.dataLayer({
    dataLayer: {
      event: 'detect_traffic_source',
      source: source,
      campaign: campaign || 'none'
    }
  });
